<template>
    <div id="overLoader" class='rounded'>
        <Loader class='loader'/>
    </div>
</template>

<script>
import Loader from "../loaders/Loader"
export default {
    name:'overLoader',
    components:{Loader}
}
</script>
<style lang="scss">
#overLoader{
    position: absolute;
    z-index: 100;display: block;
    top: 0;left: 0;
    width: 100%;height: 100%;
    background-color: rgba(255, 255, 255, 0.384);
    .loader{
        position: absolute;
        top: 35%;left: 0;
        right: 0;
    }
}
</style>
